import React from 'react';
import PropTypes from 'prop-types';

import {FormattedMessage, injectIntl} from "react-intl";

import {useFormikContext} from "formik";

import Label from "../Label";
import InputTextField from "../InputTextField";

import getNestedValue from "utils/getNestedValue";

StringTypeField.propTypes = {
    type: PropTypes.string,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    required: PropTypes.bool,
    disabled: PropTypes.bool
};

function StringTypeField({type, name, label, placeholder, required = false, disabled = false, ...props}) {
    const {values, handleChange, handleBlur, touched, errors} = useFormikContext();

    return (
        <>
            <Label required={required} htmlFor={name}>
                <FormattedMessage id={label} />
            </Label>
            <InputTextField
                disabled={disabled}
                name={name}
                onChange={handleChange}
                value={getNestedValue(values, name) ?? ''}
                placeholder={props.intl.formatMessage({id: placeholder})}
                fullWidth
                type={type}
                onBlur={handleBlur}
                error={getNestedValue(touched, name) && Boolean(getNestedValue(errors, name))}
                helperText={getNestedValue(touched, name) && getNestedValue(errors, name)}
            />
        </>
    );
}

export default injectIntl(StringTypeField);
